import { type SystemGroup } from 'kalos-modules';

export const PHONE_OTHER_PHOTOS_LABEL = 'Other photos';

/**
 * Phone surfaces only (opt-in): the photos not tied to a system are headed "Other photos" after
 * the systems' groups, and get no heading when they're all there is. The shared `groupBySystem`
 * keeps "Additional photos" for everyone else. Returns new group objects; the input is untouched.
 */
export const withPhonePhotoGroupHeadings = <T>(groups: SystemGroup<T>[]): SystemGroup<T>[] => {
  const hasSystemGroups = groups.some((group) => group.serviceItemId !== 0);
  return groups.map((group) =>
    group.serviceItemId === 0
      ? { ...group, label: hasSystemGroups ? PHONE_OTHER_PHOTOS_LABEL : '' }
      : group,
  );
};
